<template>
  <div id="PickLists" class="row">
    <TabNav :tabs="['Import PO', 'Pick List']" :selected="selected" @selected="setSelected" :key='refreshIndex'>
      <Tab :isSelected="selected === 'Import PO'">
        <div id='ImportPoForm' class='col-12' v-if='orderImported == false'>
            <form @submit.prevent="submitForm" id='ImportPo'>
                <div class="row mb-3">
                    <label for="input-sku" class="form-label">
                        Select From Confirmed Orders
                    </label>
                    <input ref='skuInput' type="text" v-model="order" class="form-control" id="input-transfer-sku" @keyup="validateOrder">
                </div>
                <div class="row mb-3">
                    <div class="col-6 offset-6 text-right">
                        <button type="button" class="btn btn-primary btn-sm btn-import" @click.prevent="importOrder" :disabled="!order">
                        Import
                        </button>
                    </div>
                </div>
                <div class='row divider'>
                    <div class='col-12'>
                        <h3>SHOW AVAILABLE ORDERS FOR:</h3>
                    </div>
                </div>
                <div class='row OrderType text-center'>
                    <div class='col-4 offset-2'>
                        <input v-model="selectedType" type='radio' id='wholesale' name='OrderType' value='wholesale' checked>
                        <label for='wholesale'>Wholesale</label>
                    </div>
                    <div class='col-4'>
                        <input v-model="selectedType" type='radio' id='web' name='OrderType' value='web'>
                        <label for='web'>Web</label>
                    </div>
                </div>
                <div class='row mt-3'>
                    <div class='col-12 TableContainer'>
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        SO#
                                    </th>
                                    <th>
                                        # of Items
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="selectedType == 'wholesale'">
                                <tr v-for="(order, index) in wholesaleOrders" :class="{'active':  selectedOrder == order}" v-if="order.Items_Ordered__c + order.Items_Available_to_Pick__c > 0"  @click="selectOrder(order)">
                                    <td>{{order.Name}}</td>
                                    <td>{{order.Items_Ordered__c + order.Items_Available_to_Pick__c}}</td>
                                </tr> 
                            </tbody>
                            <tbody v-if="selectedType == 'web'">
                                <tr v-for="(order, index) in webOrders" :class="{'active':  selectedOrder == order}" v-if="order.Items_Ordered__c + order.Items_Available_to_Pick__c > 0" @click="selectOrder(order)">
                                    <td>{{order.Name}}</td>
                                    <td>{{order.Items_Ordered__c + order.Items_Available_to_Pick__c + order.Items_Available_to_Pick__c}}</td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class='row mt-4'>
                    <div class='col-12'>
                        <button type="button" class="btn btn-primary w-100 btn-finalize-receipt" @click.prevent="importSelectedOrder()" :disabled="selectedOrder == ''"> 
                            IMPORT SELECTED ORDER
                        </button>
                    </div>
                </div>
            </form>
            
        </div> 
        <div id='ImportedPo' v-if='orderImported == true' v-model='selectedOrderData'>  
            <div class="card pt-3 TopCard">
                <div class="card-header">
                    Customer Name
                </div>
                <div class="card-body">
                    {{ selectedOrderData.custName }}
                </div>
            </div>

            <div class="card">
            <div class="card-header">
                SO #
            </div>
            <div class="card-body">
               <a :href='orderLink' target='_blank'> {{ selectedOrderData.orderNum }}</a>
            </div>
            </div>

            <div class="card">
            <div class="card-header">
                Customer PO #
            </div>
            <div class="card-body">
                {{ selectedOrderData.custPo }}
            </div>
            </div>

            <div class="card">
            <div class="card-header">
                Total # of Items
            </div>
            <div class="card-body">
                <strong>{{ itemsToPickInOrder }}</strong> items
            </div>
            </div>

            <div class="card mb-4">
            <div class="card-header bin-info">
                Bin Information
            </div>
            <div class='card-body' id='OrderBins'>
                <table class="table">
                <thead>
                    <tr>
                    <td>
                        Bin
                    </td>
                    <td>
                        Item Qty
                    </td>
                    </tr>
                </thead>
                <tbody :key='binRefreshIndex + "bin_refresh"'>
                    <tr v-for="(item, index) in currentOrderByBin" v-if="item.bin != 'MISS_SHORTSHIP'" :class="{'selected': isBinSelected(item)}" @click="selectBin(item)">
                        <td>
                            {{ item.bin }}
                        </td>
                        <td>
                            {{ item.products.length }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan='2'>Missing items: {{missingSkus.length}}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-10 offset-1 text-right">
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="pickFromOrder">
                    Pick Items in Order
                    </button>
                </div>
                </div>
                <div class="row">
                    <div class="col-6 offset-3 text-right">
                        <button type="button" class="btn btn-primary btn-sm btn-change-order" @click.prevent="changeOrder">
                        Change Order
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><!-- Temp -->

      </Tab>

      <Tab :isSelected="selected === 'Pick List'">

        <div id="ItemList">
            <div class="row mb-3 pt-3">
            <label for="input-sku" class="form-label">
                Scan SKU to Pick
            </label>
            <input type="text" v-model="skuToPick" class="form-control" id="input-sku-to-pick" @keyup="pickItem" :disabled="!binsForPicking[this.displayBinPage]">
            <span class='scanError' v-if="scanError != ''">{{scanError}}</span>
            </div>
            <div class="row mb-3">
                <div class="col-6 offset-6 text-right">
                    <button type="button" class="btn btn-primary btn-sm btn-import" @click.prevent="exec_pick" :disabled="!skuToPick">
                    Pick Item
                    </button>
                </div>
            </div>
            <div class='bin' v-for="(item, index) in binsForPicking">
                <div v-if='index == displayBinPage'>
                    <div class='row divider'>
                        <div class='col-12'>
                            <h3>Items in {{item.bin}} ({{item.products.length}} items)</h3>
                        </div>
                    </div>
                    <div class="pt-3 row ProductInBin" v-for="(product, index) in item.products">
                        <div class="col-3">
                            <img :src="product.image" class="img-fluid">
                        </div>
                        <div class="col-sm-5 col-xs-9">
	                        <div class="form-group mb-3">
	                            <div class="form-label">
	                            SKU
	                            </div>
	                            <div>
	                            {{ product.sku }}
	                            </div>
	                        </div>
	                        <div class="form-group mb-3">
	                            <div class="form-label">
	                            Description
	                            </div>
	                            <div>
	                            {{ product.description }}
	                            </div>
	                        </div>
                        </div>
                        <div class="col-sm-4 col-xs-9 offset-xs-3 offset-sm-0">
	                        <div class="form-group mb-3">
	                            <div class="form-label">
	                            Door
	                            </div>
	                            <div>
	                            {{ product.door }}
	                            </div>
	                        </div>
	                        <div class="form-group mb-3">
	                            <div class="form-label">
	                            Offer
	                            </div>
	                            <div>
	                            {{ product.offer }}
	                            </div>
	                        </div>
                            <div class="MissingLink text-right">
                                <a href="#" @click='addSkuToMissing(product)'>Mark as missing</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='row divider'>
                <div class='col-12'>
                    <h3>Picked Items</h3>
                </div>
            </div>
            <div v-for="(item, index) in pickedItems" class='row'>
                <div class='col-12' :class="selectedPickedSkus.includes(item) ? 'list-group-item active' : 'list-group-item'" @click='selectPickedItem(item)'>
                    <span>{{item.product.sku}}</span>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6 offset-6">
                    <button type="button" class="btn btn-success btn-sm btn-unpick" :disabled='selectedPickedSkus.length == 0' @click.prevent="unpickSelected()">
                    Unpick Selected
                    </button>
                </div>
            </div>
            <div class='row divider'>
                <div class='col-12'>
                    <h3>Missing Items</h3>
                </div>
            </div>
             <div v-for="(item, index) in missingSkus" class='row'>
                <div class='col-12 list-group-item'>
                    <span>{{item.sku}}</span>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6 text-center">
                    <!-- <button type="button" class="btn btn-secondary btn-sm btn-prevBin" :disabled='displayBinPage == 0' @click.prevent="prevBin"> -->
                    <button type="button" class="btn btn-secondary btn-sm btn-prevBin" :disabled='binsForPicking.length == 1' @click.prevent="prevBin">
                    Prev Bin
                    </button>
                </div>
                <div class="col-6 text-center">
                    <!-- <button type="button" class="btn btn-success btn-sm btn-nextBin" :disabled='displayBinPage == displayOrderByBin.length - 1' @click.prevent="nextBin"> -->
                    <button type="button" class="btn btn-success btn-sm btn-nextBin" :disabled='binsForPicking.length == 1' @click.prevent="nextBin">
                    Next Bin
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-right">
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="setSelected('Import PO')">
                    Return to Bin List
                    </button>
                </div>
            </div>
        </div>
      </Tab>
    </TabNav>
  </div>
</template>
<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'

  export default {
    name: 'PickLists',
    components: {
      TabNav,
      Tab,
    },
    data() {
      return {
        selected : 'Import PO',
        skuToPick : '',
        itemToPick: {},
        orderImported: false,
        order: '',
        customerName : '',
        customerPoNumber : '',
        enteredOrders: [],
        selectedOrders: [],
        pickedItems: [],
        selectedId: '',
        selectedSkus: [],
        selectedOrder: '',
        OrderByBin: [],
        displayOrderByBin: [],
        currentOrders:[],
        selectedType: 'wholesale',
        displayBinPage: 0,
        selectedPickedSkus:[],
        scanError: '',
        division: this.$store.getters['PowerScan/division'],
        timestamp: '',
        refreshIndex: 0,
        binRefreshIndex: 1,
        selectedBins:[]
      }
    },
    mounted(){
        this.getCurrentOrders()
    },
    computed:{
        orderLink(){
            return 'https://wgaca--dev--rstk.visualforce.com//apex/SalesOrderWorkbench?div=aATf4000000GnHmGAK&ordno='+ this.selectedOrderData.orderNum
        },
        wholesaleOrders(){
            return this.$store.getters['PowerScan/currentWholesaleOrders'];
        },
        webOrders(){
            return this.$store.getters['PowerScan/currentWebOrders'];
        },
        selectedOrderData(){
            return this.$store.getters['PowerScan/currentOrderDetails'];
        },
        currentOrderByBin:{
            get(){
                //console.log('checking currentOrder value');
                return this.$store.getters['PowerScan/currentOrderByBin'];
            },
            set(value){
                //console.log('setting from computed propery')
                this.$store.dispatch('PowerScan/set', {field: 'currentOrderByBin', value: value});
            }
        },
        currentSite(){
            return this.$store.getters['PowerScan/currentSite'];
        },
        selectedSite(){
            return this.$store.getters['PowerScan/selectedSite'];
        },
        itemsToPickInOrder(){
            return this.selectedOrder.Items_Ordered__c + this.selectedOrder.Items_Available_to_Pick__c
        },
        binsForPicking(){
            return this.selectedBins.length > 0 ? this.selectedBins : this.displayOrderByBin
        },
        missingSkus:{
            get(){
                return this.$store.getters['PowerScan/missingFromCurrentOrder']
            },
            set(value){
                return this.$store.dispatch('PowerScan/set', {field:'missingFromCurrentOrder', value: value})
            }
        },
    },
    watch: {
        currentOrderByBin(newValue) {
            //console.log('yes, computed property changed:', JSON.stringify(newValue));
        },
        binsForPicking(newValue){
            //console.log('yes, bins for picking changed:', JSON.stringify(newValue));
        }
    },
    methods: {
      setSelected(tab) {
        this.selected = tab;
        this.refreshIndex++;
        this.binRefreshIndex++;
        if((this.selected == 'Pick List') && (this.selectedBins.length == 0)){
            this.scanError = 'No Bin Selected';
        }else{
            this.scanError = '';
        }
      },
      getTimeStamp(){
            const today = new Date();
            const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = date +' '+ time;
            this.timestamp = dateTime;
      },
      async getCurrentOrders(){
          //console.log("getting orders - ");
          this.currentOrders = await this.$store.dispatch('PowerScan/fetchCurrentOrders')
      },
      validateOrder(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          //console.log('Enter pressed - sku: ', this.order);
          this.importOrder(null);
          
        }
      },
      importOrder(e){
          //e.preventDefault();
          this.scanError = '';
          let currentSelectedOrders = this.selectedType == 'wholesale' ? this.wholesaleOrders : this.webOrders;
          if(currentSelectedOrders.findIndex(x => x.Name == this.order) == -1){
             // console.log('error?');
            //this.enteredOrders.push(this.order)
            this.scanError = 'Order Not Found';
          }
          else{
            //  console.log('success?');
            this.selectedOrder = currentSelectedOrders[currentSelectedOrders.findIndex(x => x.Name == this.order)];
            this.importSelectedOrder();
          }
          this.order = '';
      },
      selectOrder(order){
        this.selectedOrder = order;
        this.selectedId = order.id;
        this.selectedskus = order.skus;
        if ( this.selectedOrders.includes(order) ) {
          this.selectedOrders.splice(this.selectedOrders.indexOf(order), 1)
        } else {
          this.selectedOrders.push(order)
        }
      },
      selectBin(bin){
         // console.log('select bin - ', bin);
        if ( this.selectedBins.includes(bin) ) {
          //    console.log("remove bin - "+ bin.bin + 'at - '+ this.selectedBins.indexOf(bin));
          this.selectedBins.splice(this.selectedBins.indexOf(bin), 1)
        } else {
          this.selectedBins.push(bin);
        //  console.log("add bin - " +  bin.bin);
        }
        this.binRefreshIndex++;

      },
      totalNumberOfItems() {
        return this.selectedOrder.Items_Ordered__c;
      },
      async getItemData(sku){
            let ItemData = await this.$store.dispatch('ItemCard/fetchOfferInventoryData', sku);
            //console.log('what about this data? - ', ItemData);
            this.customerName = ItemData.custName;
            this.customerPoNumber = ItemData.custPo;
            //return ItemData;
      },
      submitForm(){
          //TODO: Submit form
      },
      changeOrder(){
          this.orderImported = false;
          this.enteredOrders = [];
          this.selectedOrders = [];
          this.pickedItems = [];
          this.displayBinPage = 0;
          this.missingSkus = [];
          this.selectedPickedSkus = [];
          this.selectedSkus = [];
          this.selectedBins = [];
          this.selectedOrder = '';
          this.OrderByBin = [];
          this.displayOrderByBin = [];
          this.currentOrders = [];
      },
      importSelectedOrder(){
          this.orderImported = true;
          this.$store.dispatch('PowerScan/fetchOrderDetails', this.selectedOrder);
      },
      pickFromOrder(){
          //console.log('Pick items - why is it changing the computed property? - ', this.currentOrderByBin);
          this.selected = 'Pick List';
          this.displayOrderByBin = this.currentOrderByBin;
          if(this.displayOrderByBin.findIndex(x => x.bin == 'MISS_SHORTSHIP') != -1){
            this.displayOrderByBin.splice(this.displayOrderByBin.findIndex(x => x.bin == 'MISS_SHORTSHIP'), 1);
          }
      },
      isBinSelected(item){
            return this.selectedBins.includes(item) ? true : false;
      },
      exec_pick(e){
        this.scanError = '';
        //console.log("picking - ", this.skuToPick);
        let originBin = this.binsForPicking[this.displayBinPage].bin;
        let pickedItemIndex = this.binsForPicking[this.displayBinPage].products.findIndex(x => x.sku == this.skuToPick)
        this.itemToPick = this.binsForPicking[this.displayBinPage].products[pickedItemIndex]
        if(pickedItemIndex != -1){
            this.binsForPicking[this.displayBinPage].products.splice(pickedItemIndex, 1)
            if(this.binsForPicking[this.displayBinPage].products.length == 0){
            //    this.displayOrderByBin.splice(this.displayBinPage, 1);
                this.nextBin();
            }
            if (this.timestamp == '') this.getTimeStamp(); 
            let pickedItem = {
                name: 'PickItem',
                req_ref: Math.random().toFixed(10),
                product: this.itemToPick, 
                bin: originBin,
                params: {
                    rstk__soprod_prod__c: this.itemToPick.sku,
                    rstk__sydata_sohdr__c: this.selectedOrder.Id ,
                    rstk__sydata_txnqty__c: 1,
                    rstk__sydata_txntype__c: 'Sales Order Pick-Pack',
                    rstk__sydata_sydiv__r: this.division,
                    rstk__sydata_icitem__r: `${this.division}_${this.itemToPick.sku}`,
                    //rstk__sydata_docno__c: this.timestamp, //timestamp doesn't seem to work
                    rstk__sydata_soline__c: this.itemToPick.productOrderId
                }
            }
            this.pickedItems.push(pickedItem);
            let pickedItemSubmit = {
                name: pickedItem.name,
                req_ref: pickedItem.req_ref,
                params: pickedItem.params,
                product: pickedItem.product,
                api_token: 'token'
            }
            const response = this.$store.dispatch('PowerScan/transferInventory', pickedItemSubmit);
        }else{
            this.scanError = 'Item not in Order';
        }
        this.skuToPick = '';
      },
      
      exec_unpick(ItemToUnpick){
        //let orderState = this.$store.getters['PowerScan/currentOrderByBin'] 
        //console.log('Item to unpick - ', ItemToUnpick);
        let pickedItem = {
            name: 'PickItem',
            req_ref: Math.random().toFixed(10),
            product: ItemToUnpick, 
            //bin: `${this.division}_${ItemToUnpick.loc_id}_${ItemToUnpick.loc_num}`,
            params: {
                rstk__soprod_prod__c: ItemToUnpick.sku,
                rstk__sydata_sohdr__c: this.selectedOrder.Id ,
                rstk__sydata_txnqty__c: 1,
                rstk__sydata_txntype__c: 'Sales Order Pick-Pack Reversal ',
                rstk__sydata_sydiv__r: this.division,
                rstk__sydata_icitem__r: `${this.division}_${ItemToUnpick.sku}`,
                //rstk__sydata_docno__c: this.timestamp, //timestamp doesn't seem to work
                rstk__sydata_soline__c: ItemToUnpick.productOrderId
            }
        }
        let unpickedItemSubmit = {
                name: pickedItem.name,
                req_ref: pickedItem.req_ref,
                params: pickedItem.params,
                api_token: 'token'
            }
        const response = this.$store.dispatch('PowerScan/transferInventory', unpickedItemSubmit);
      },
      pickItem(e){
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
            e.preventDefault()
            this.exec_pick(null);
        }
      },
      selectPickedItem(item){
        if ( this.selectedPickedSkus.includes(item) ) {
          this.selectedPickedSkus.splice(this.selectedPickedSkus.indexOf(item), 1)

        } else {
          this.selectedPickedSkus.push(item)
        }
      },
      addSkuToMissing(product){
        let currentMissingSkus = this.missingSkus;
        //console.log(product.sku, ' is missing')
        let missingItemIndex = this.displayOrderByBin[this.displayBinPage].products.indexOf(product)
        //console.log('index - ', missingItemIndex)
        let missingProduct = {
            name: 'InventoryTransfer',
            req_ref: Math.random().toFixed(10),
            product: product,
            params: {
                item: product.sku,
                type: 'INVLOCLOC',
                quantity: 1,
                from_div: this.division,
                to_div: this.division,
                from_site: product.siteId,
                to_site: this.selectedSite.Id,
                from_locid: `${this.division}_${this.currentSite}_${product.loc_id}`,
                to_locid: `${this.division}_${this.currentSite}_MISS`,
                from_proj: product.proj,
                to_proj: product.proj,
                from_locnum: product.loc_num,
                to_locnum: "SHORTSHIP"
            },
            api_token: 'token'
        };
        const response = this.$store.dispatch('PowerScan/transferInventory', missingProduct);
        /*console.log('how many bins? - ', this.currentOrderByBin.length)
        for(let i=0; i < this.currentOrderByBin.length; i++){
            console.log("am I accessing the bin correctly? -  ", this.currentOrderByBin[i].bin )
        }*/
        
        //console.log("is there already a missing bin? -  ", this.currentOrderByBin.findIndex(x => x.bin == 'MISS_SHORTSHIP') )
        let tempOrder = this.binsForPicking;
        if(this.currentOrderByBin.findIndex(x => x.bin == 'MISS_SHORTSHIP') == -1){
            let missingBin = {
                bin: 'MISS_SHORTSHIP',
                products:[]
            }
            missingBin.products.push(product);
            tempOrder.push(missingBin);
            this.currentOrderByBin = tempOrder;
            //console.log('pushing into list - ', missingBin);
        }else{
            tempOrder[tempOrder.findIndex(x => x.bin == 'MISS_SHORTSHIP')].products.push(product);
            this.currentOrderByBin = tempOrder;
            //console.log('pushing into missingBin - ', product);
        }
        this.displayOrderByBin[this.displayBinPage].products.splice(missingItemIndex, 1)
        if(this.displayOrderByBin[this.displayBinPage].products.length == 0){
        //    this.displayOrderByBin.splice(this.displayBinPage, 1);
            this.nextBin();
        }
          currentMissingSkus.push(product)
          this.missingSkus = currentMissingSkus;
      },
      unpickSelected(){
          for(let i = 0; i < this.selectedPickedSkus.length; i++){
              //this.unpick(this.selectedPickedSkus[i]);
              this.exec_unpick(this.selectedPickedSkus[i].product);
          }
          this.selectedPickedSkus = [];
      },
      unpick(item){
          let pickedBinIndex = this.currentOrderByBin.findIndex(x => x.bin == item.bin);
          let pickedItemIndex = this.pickedItems.findIndex(x => x == item);
          if (this.displayOrderByBin.findIndex(x => x.bin == item.bin) == -1){
              this.displayOrderByBin.push(item);
          }else{
              this.displayOrderByBin[pickedBinIndex].products.push(item.product);
          }
          this.pickedItems.splice(pickedItemIndex, 1)
      },
       prevBin(){
          if(this.displayBinPage == 0){
              this.displayBinPage = this.binsForPicking.length - 1;
          }else{
            this.displayBinPage--;
          }
          if(this.binsForPicking[this.displayBinPage].products.length == 0){
              for(let i=this.binsForPicking.length - 1; i >= 0; i-- ){
                    if(this.binsForPicking[i].products.length > 0){
                        this.displayBinPage = i;
                        break;
                    }
                }
          }
      },
      nextBin(){
          let startingBin = this.displayBinPage;
          if(this.displayBinPage == this.binsForPicking.length - 1){
              this.displayBinPage = 0;
          }else{
            this.displayBinPage++;
          }
          if(this.binsForPicking[this.displayBinPage].products.length == 0){
             // let binCheck = this.displayBinPage <= this.binsForPicking.length ?  this.displayBinPage + 1 : 0;
                for(let i=0; i < this.binsForPicking.length; i++ ){
                    if(this.binsForPicking[i].products.length > 0){
                        this.displayBinPage = i;
                        break;
                    }
                }
          }
       }
    },
  }
</script>
